import {
  BatchCarrierMethod,
  FetcherConfig,
  PaginatedData,
} from '@seller-hermes/app/types';
import { Driver } from '@seller-hermes/features/api/driver.types';
import { Route } from '@seller-hermes/features/route/routes.types';
import api from '@seller-hermes/utils/api';

export const createDriverRoute = (body: {
  start_warehouse_id: string;
  end_warehouse_id: string;
  invoices: string[];
}) => {
  return api.post(`/v1/driver/route`, body).then((response) => response.data);
};
export const cancelDriverRoute = (route_id: string) =>
  api
    .put(`/v1/driver/route/${route_id}/cancel`)
    .then((response) => response.data);

export const getDriverRoute = async () => {
  return api.get(`/v1/driver/route`).then((response) => response.data);
};

export interface UpdateRouteDriverParams {
  id: string;
  document_number: string;
}

export interface UpdateRouteCostParams {
  id: string;
  route_cost: number;
}

export interface RequestCarrierPickupParams {
  id: string;
  integration_id: string;
  carrier_method_type: string;
}

export class RoutesQuery {
  // `signal` vem do react-query: quando a busca muda, a requisição antiga é
  // abortada em vez de seguir ocupando o back.
  static search = async (
    body: FetcherConfig,
    signal?: AbortSignal,
  ): Promise<PaginatedData<Route[]>> => {
    return api
      .post('/routes-page/v1/search/routes', body, { signal })
      .then((res) => res.data);
  };

  static getRouteInfo = async ({ id }: { id: string }): Promise<Route> => {
    return api
      .get(`/routes-page/v1/search/route?route_id=${id}`)
      .then((res) => res.data);
  };

  // O cancelamento de rota de transportadora é síncrono: chama a transportadora
  // para cada pedido antes de responder. 35s cobre o limite de 29s do API
  // Gateway; com os 15s padrão o front mostraria erro com o cancelamento ainda
  // em andamento no backend.
  static cancel = async ({ id }: { id: string }): Promise<Route> => {
    return api
      .put(`/routes-page/v1/routes/${id}/cancel`, undefined, { timeout: 35000 })
      .then((res) => res.data);
  };

  static duplicate = async ({ id }: { id: string }): Promise<Route> => {
    return api
      .post(`/routes-page/v1/routes/${id}/duplicate`, undefined)
      .then((res) => res.data);
  };

  static updateDriver = async ({
    id,
    document_number,
  }: UpdateRouteDriverParams): Promise<Route> => {
    return api
      .put(`/v2/routes/${id}/driver`, {
        driver_document: document_number,
      })
      .then((res) => res.data);
  };

  static updateCost = async ({
    id,
    route_cost,
  }: UpdateRouteCostParams): Promise<Route> => {
    return api
      .put(`/v2/routes/${id}/cost`, {
        route_cost: route_cost,
      })
      .then((res) => res.data);
  };

  static requestPickup = async (
    params: RequestCarrierPickupParams,
  ): Promise<Route> => {
    const { id, ...body } = params;
    return api
      .put(`/routes-page/v1/routes/${id}/request-delivery`, body)
      .then((res) => res.data);
  };

  static searchDrivers = (
    body: FetcherConfig,
  ): Promise<PaginatedData<Driver[]>> =>
    api.post('/create-route-page/v1/search/drivers', body).then((v) => v.data);

  static getAllMyUserSellersCarrierMethodsWhoAreBatchV2 = async (): Promise<
    BatchCarrierMethod[]
  > =>
    api.get('/routes-page/v2/batch-carrier-methods').then((v) => {
      return v.data;
    });
}
